import React from 'react';
import PropTypes from 'prop-types';

import { Text, Link, Title, Box } from '@nerdwallet/currency';
import Image from '@nerdwallet/react-image';

import { stringInputSpec, titleInput } from '../../lib/editing-configs';

import styles from './featured-story.module.less';

const FeaturedStory = ({ title, body, linkUrl, previewImg }) => (
  <Box className={styles.story__cont}>
    {previewImg ? (
      <Link href={linkUrl} target="_blank">
        <Image
          className={styles['story-image__cont']}
          src={previewImg}
          objectFit="cover"
          objectPosition="center"
          alt={title}
        >
          <Box className={styles['story-image__overlay']} />
        </Image>
      </Link>
    ) : null}
    <Box className={styles['story-body__cont']}>
      <Link href={linkUrl} color="neutral-darkest" target="_blank">
        <Title size="large" component="p" className={styles['story-title']}>
          {title}
        </Title>
      </Link>
      <Text component="p">{body}</Text>
    </Box>
  </Box>
);

FeaturedStory.displayName = 'FeaturedStory';

FeaturedStory.propTypes = {
  title: PropTypes.string,
  body: PropTypes.string,
  linkUrl: PropTypes.string,
  previewImg: PropTypes.string,
};

FeaturedStory.defaultProps = {
  title: '',
  body: '',
  linkUrl: '',
  previewImg: '',
};

FeaturedStory.getEditingConfig = () => [
  titleInput,
  stringInputSpec('body', 'Preview body text'),
  stringInputSpec('linkUrl', 'URL of story'),
  stringInputSpec('previewImg', 'Preview image URL'),
];

export default FeaturedStory;
